import {
  RESET_PROFILES,
  RESET_PROFILE,
  RESET_ERROR,
  GET_PROFILES_CLIENT,
  GET_PROFILES_BACKOFFICE,
  SET_PROFILES,
  API_ERROR,
  GET_PROFILE,
  SET_PROFILE,
  CREATE_PROFILE,
  CREATE_PROFILE_SUCCESS,
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  DELETE_PROFILE,
  DELETE_PROFILE_SUCCESS,
} from "./actionTypes";

export const resetProfiles = () => {
  return {
    type: RESET_PROFILES,
    payload: {},
  };
};

export const resetProfile = () => {
  return {
    type: RESET_PROFILE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getProfilesBackoffice = (page, qnt, name, description, isForm ) => {
  return {
    type: GET_PROFILES_BACKOFFICE,
    payload: { page, qnt, name, description, isForm  },
  };
};
export const getProfilesClient = (idCompany, page, qnt, name, description, isForm) => {
  return {
    type: GET_PROFILES_CLIENT,
    payload: { idCompany, page, qnt, name, description, isForm },
  };
};
export const setProfiles = (data, qtdDefault, idCompany) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_PROFILES,
    payload: { ...data, paging, idCompany },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createProfile = (newProfileValues, idCompany, idDepartment) => {
  return {
    type: CREATE_PROFILE,
    payload: { newProfileValues, idCompany, idDepartment },
  };
};
export const createProfileSuccess = (message) => {
  return {
    type: CREATE_PROFILE_SUCCESS,
    payload: { message },
  };
};

export const getProfile = (idProfile, idCompany, isForm) => {
  return {
    type: GET_PROFILE,
    payload: { idProfile, idCompany, isForm },
  };
};
export const setProfile = (data) => {
  return {
    type: SET_PROFILE,
    payload: { data },
  };
};

export const editProfile = (
  idProfile,
  newProfileValues,
  idCompany,
  idDepartment
) => {
  return {
    type: EDIT_PROFILE,
    payload: { idProfile, newProfileValues, idCompany, idDepartment },
  };
};
export const editProfileSuccess = (message) => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload: { message },
  };
};

export const deleteProfile = (idProfile, idCompany, idDepartment) => {
  return {
    type: DELETE_PROFILE,
    payload: { idProfile, idCompany, idDepartment },
  };
};
export const deleteProfileSuccess = (message) => {
  return {
    type: DELETE_PROFILE_SUCCESS,
    payload: { message },
  };
};
